import * as qs from 'qs';
import URL from 'url-parse';
import * as r from 'ramda';
import * as reducers from './reducers';
import {selectSelectedPizzas} from './selectors';

let prevHeadXhr = null;

export function updateUrl(pizzaIds) {
    const url = new URL(window.location.href);
    const originalQuery = qs.parse(r.replace(/^\?/, '', url.query));
    const newQuery = r.mergeRight(originalQuery, {halves: pizzaIds});
    url.query = `?${qs.stringify(newQuery)}`;
    const newUrl = url.toString();
    history.replaceState(history.state, document.title, newUrl);
    if (prevHeadXhr) {
        prevHeadXhr.abort();
    }
    // if user logins via oauth, he should be redirected to correct url
    //prevHeadXhr = $.ajax({url: location.href, method: 'HEAD'});
}

export function updateFormInput(formInputId, pizzaIds) {
    $('#' + formInputId).val(pizzaIds.join(','));
}

export function getNewModalId(mode, pizzaCount) {
    let newModalId;
    let submitButton = $('#half-pizza-submit-button');
    if (submitButton.data('modal') !== '#modal-no-shipment') {
        if (mode === reducers.MODE_TWO_HALVES && pizzaCount === 1) {
            newModalId = '#modal-half-pizza-second-pizza-missing';
        } else if (pizzaCount === 0) {
            newModalId = '#modal-half-pizza-no-pizza-chosen';
        } else {
            newModalId = false;
        }
    }

    return newModalId;
}

export function submitForm(formInputId) {
    let form = $('#' + formInputId);
    let data = $(form).serialize();
}

export function getImagesFromSelectedPizzas(selectedPizzaIds) {
    return selectedPizzaIds.map((pizzaId, index) => {
        let image = $('#half-pizza-image-' + pizzaId);
        if (image.length) {
            return {
                position: index === 0 ? 'left' : 'right',
                src: image.attr('src'),
                alt: image.attr('alt'),
            };
        }
    });
}
